import { ICapture, ISegment } from '../types'
import Imaging from './imaging'
import { getCropForAspectRatio } from './utils'

const SESSION_STORAGE_KEY = 'SUPERCUT_UPLOAD_DATA'

class Uploader {
    static setUploadSessionData = data => {
        window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data))
    }

    static getUploadSessionData = () => {
        return JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_KEY) || '{}')
    }

    static clearUploadSessionData = () => {
        Uploader.setUploadSessionData({})
    }

    static redirectToUpload = async (capture: ICapture, segments: ISegment[]) => {
        const videoUrls = await Promise.all(
            segments.map(async segment => {
                let url = segment.video_url

                const { captionWatermark, trimmedStartTime, trimmedEndTime, aspectRatio } = segment.editParams

                if (captionWatermark) {
                    const watermarkData = captionWatermark
                    url = await Imaging.burnWatermark(url, watermarkData)
                }

                if (trimmedStartTime > 0 || trimmedEndTime !== segment.duration) {
                    const start = trimmedStartTime
                    const duration = trimmedEndTime - trimmedStartTime
                    url = Imaging.trim(url, start, duration)
                }

                if (aspectRatio !== 'original') {
                    const cropDimensions = getCropForAspectRatio(capture!.width, capture!.height, aspectRatio)
                    url = Imaging.crop(url, cropDimensions.x, cropDimensions.y, cropDimensions.w, cropDimensions.h)
                }

                return url
            })
        )

        Uploader.setUploadSessionData({ urls: videoUrls })
        const uploadURL = `/upload/finalize?is_supercut=1`
        window.location.href = uploadURL
    }
}

export default Uploader
